var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfidenceBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 12.5502C12.9943 12.5502 13.8002 11.7443 13.8002 10.7502C13.8002 9.75608 12.9943 8.9502 12.0002 8.9502C11.0061 8.9502 10.2002 9.75608 10.2002 10.7502C10.2002 11.7443 11.0061 12.5502 12.0002 12.5502Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85005 21.5301V18.3101C8.85005 17.4401 8.64005 16.5901 8.24005 15.8301C7.03005 13.5201 4.43005 8.59011 4.43005 8.59011C4.17005 8.10011 4.36005 7.50011 4.85005 7.24011C5.34005 6.98011 5.94005 7.17011 6.20005 7.66011L8.88005 12.7501C9.49005 13.9101 10.69 14.6301 12 14.6301C13.31 14.6301 14.51 13.9101 15.12 12.7501L17.8 7.66011C18.06 7.17011 18.66 6.98011 19.15 7.24011C19.64 7.50011 19.83 8.10011 19.57 8.59011C19.57 8.59011 16.98 13.5201 15.76 15.8301C15.36 16.6001 15.15 17.4501 15.15 18.3101V21.5301",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.47998V5.29998",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5498 3.7002L9.0098 6.1302",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4502 3.7002L14.9902 6.1302",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfidenceBuilding);
export default __webpack_public_path__ + "static/media/Confidence Building.5ae34453cb6969b32fe8b3bfe5847d45.svg";
export { ForwardRef as ReactComponent };